import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { redoEditFeature, undoEditFeature } from "../../../ducks/editFeature/editFeature";
import { canRedoEditFeature, canUndoEditFeature, getCurrentEditFeature } from "../../../ducks/editFeature/selectors";
import { Positions } from "../../../ducks/geometryEditor/geometryEditor";
import { FeatureAttribute } from "../components/Attributes/FeatureAttributeField";

type FeatureEditHistory = [
  {
    attributes: FeatureAttribute[];
    geometry: Positions;
  },
  {
    undo: VoidFunction;
    redo: VoidFunction;
    canUndo: boolean;
    canRedo: boolean;
  },
];

export const useFeatureEditHistory = (): FeatureEditHistory => {
  const dispatch = useDispatch();
  const { attributes, geometry } = useSelector(getCurrentEditFeature);

  const undo = useCallback(() => dispatch(undoEditFeature()), []);
  const redo = useCallback(() => dispatch(redoEditFeature()), []);
  const canUndo = useSelector(canUndoEditFeature);
  const canRedo = useSelector(canRedoEditFeature);

  return useMemo(
    () => [
      { attributes, geometry },
      { undo, redo, canUndo, canRedo },
    ],
    [attributes, canRedo, canUndo, geometry, redo, undo],
  );
};
